import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api";
import { ID_LIGA } from "../App";

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-radius: 10px;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 120px;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  height: 38px;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
`;

const Button = styled.button`
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 6px;
  border: none;
  background-color: #2980b9;
  color: white;
  height: 38px;
  font-size: 14px;
  font-weight: 600;
  align-self: flex-end;
`;

const FormRodada = ({ getUsers, onEdit, setOnEdit }) => {
  const ref = useRef();

  useEffect(() => {
    if (onEdit) {
      const user = ref.current;
      user.id.value = onEdit.id;
      user.rodada.value = onEdit.rodada;
      user.valorParticipante.value = onEdit.valorParticipante;
      user.valorRodada.value = onEdit.valorRodada;
      user.inicio.value = onEdit.inicio;
      user.fim.value = onEdit.fim;
      user.visivel.checked = onEdit.visivel;
    }
  }, [onEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = ref.current;

    if (!user.rodada.value || !user.valorParticipante.value || !user.valorRodada.value || !user.inicio.value) {
      return toast.warn("Preencha todos os campos obrigatórios!");
    }

    const req = {
      id: Number(user.id ? user.id.value : 0),
      rodada: Number(user.rodada.value),
      idLiga: ID_LIGA,
      valorParticipante: Number(user.valorParticipante.value),
      valorRodada: Number(user.valorRodada.value),
      inicio: user.inicio.value,
      fim: user.fim.value,
      visivel: user.visivel.checked,
    };

    await api.post("liga/addRodada", req)
      .then(({ data }) => toast.success(data))
      .catch(({ data }) => toast.error(data));

    user.id.value = "";
    user.rodada.value = "";
    user.valorParticipante.value = "";
    user.valorRodada.value = "";
    user.inicio.value = "";
    user.fim.value = "";
    user.visivel.checked = false;

    setOnEdit(null);
    getUsers();
  };

  return (
    <FormContainer ref={ref} onSubmit={handleSubmit}>
      <Row>
        <InputArea style={{ maxWidth: 60 }}>
          <Label>Id</Label>
          <Input name="id" disabled style={{ background: "#f5f5f5" }} />
        </InputArea>
        <InputArea style={{ maxWidth: 80 }}>
          <Label>Rodada *</Label>
          <Input name="rodada" type="number" />
        </InputArea>
        <InputArea>
          <Label>Vl Participante *</Label>
          <Input name="valorParticipante" type="number" step="0.01" />
        </InputArea>
        <InputArea>
          <Label>Vl Rodada *</Label>
          <Input name="valorRodada" type="number" step="0.01" />
        </InputArea>
      </Row>
      <Row>
        <InputArea>
          <Label>Início *</Label>
          <Input name="inicio" type="datetime-local" />
        </InputArea>
        <InputArea>
          <Label>Fim</Label>
          <Input name="fim" type="datetime-local" />
        </InputArea>
        <InputArea style={{ maxWidth: 80, alignItems: "center" }}>
          <Label>Visível</Label>
          <Input name="visivel" type="checkbox" style={{ width: 20, height: 20 }} />
        </InputArea>
        <Button type="submit">Salvar</Button>
      </Row>
    </FormContainer>
  );
};

export default FormRodada;

